<!-- TODO Add side bar navication for filters -->
<!-- TODO Add Actions menu button to allow the action to be place in the top bar. -->
<div class="navToTopButton">
    <button mat-fab (click)="scrollToTop()" [disabled]="!navToTop" [matTooltipPosition]="'left'" matTooltip="Return to top">
      <mat-icon>vertical_align_top</mat-icon>
    </button>
</div>
<div class="container-flux">
    <div class="row" style="margin: 0px;padding: 0px;">
        <div class="col-12" style="padding: 0px;">
            <mat-toolbar class="rsg-toolbar">
                <div class="row" style="padding: 0px;">
                    <div class="col-4">
                    </div>
                    <div class="col-4" style="text-align: center;">
                        <!-- <img src="/assets/images/favicon.ico" width="35" height="35" /> -->
                        <img src="/assets/images/csLogo.png" width="100" height="35" style="background-color: white; padding: 2px;" *ngIf="loggedIn" /> &nbsp;&nbsp;
                        <span style="vertical-align: text-bottom;"><strong>Delivery Rate App</strong></span>
                    </div>
                    <div class="col-4">
                        <div class="row" style="padding: 0px;">
                            <div class="col-7" style="font-size: 15px;" >
                            </div>
                            <div class="col-5" >
                                <button [matMenuTriggerFor]="menu2" *ngIf="loggedIn" mat-flat-button style="position: absolute;right:10px">{{username}} <mat-icon>portrait</mat-icon></button>
                                <mat-menu #menu2="matMenu">
                                    
                                    <button mat-menu-item (click)="logout()" routerLink="/login">Logout</button>
                                    <!-- <bookmark-manager [item]="bookmarkInput" [subMenu]="true" ></bookmark-manager> -->
                                </mat-menu>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </mat-toolbar>
        </div>
        <div class="col-12 sub-title" style="background-color: #888; color:whitesmoke; text-align: center; font-size: 20px; height: 30px;">
            <span>{{subTitle}}</span>
        </div>
    </div>
    
</div>
    <mat-sidenav-container class="container-flux" [hasBackdrop]="false">
        <mat-sidenav #sidenav mode="over" class="off-canvas-left" 
                        [fixedInViewport]="true" 
                        [fixedTopGap]="63"
                        [fixedBottomGap]="43" style="width: 35%; min-width: 250px; max-width: 500px;" >
                <div class="row navHeader" style="margin:0px;">
                    <div class="col-8" style="padding:0px">
                    </div>
                    <div class="col-2" style="padding:0px">
                    </div>
                    <div class="col-2" style="padding:0px">
                        <button mat-stroked-button color="warn" class="fill-w" style="background-color: whitesmoke;" (click)="sidenav.close()" ><mat-icon>close</mat-icon></button>
                    </div>
                </div>
                <div class="row" style="margin:0px; padding-bottom: 0px;">
                    <!-- <div class="col-12" style="padding:0px" *ngIf="filterFields.length>0">
                        <advance-filtering #navFilters [fieldLists]="filterFields" [workingFilters]="filterValues" [slimDisplay]="true" (filterFields)="setFilters($event)" ></advance-filtering>
                    </div> -->
                </div>
        </mat-sidenav>
        <!-- (click)="closeSideNav()" -->
        <mat-sidenav-content [formGroup]="options" >
            <!-- content Goes here!!! -->
            <div style="height: calc(100vh - 137px); overflow-y: auto;" id="contentContainer" >
                <br>
                <router-outlet></router-outlet>
                <br>
                <br>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
    <splash-screen [animationType]="'fade-out'" [duration]="2" [animationDuration]="1"></splash-screen>
    <!-- <div style="height: calc(100vh - 107px);overflow-y: auto;"  >
        <router-outlet></router-outlet>
    </div> -->
<!-- </div> -->
<div class="container-flux">
    <div style=" position: absolute; bottom: 0px; left: 0px; color: #777; font-size: 9pt; padding-left: 5px; padding-right: 5px; min-width: 200px; max-width: 800px; border: 1px solid #444; ">
        System:   {{footerMsg}}
    </div>
    <footer id="footer">
        <div class="row" style="margin-right: auto;">
            <div class="col-2" style="padding-right: 0px;">
                <small><span id="footerAppName">Delivery Rate App</span></small>
            </div>
            <div class="col-8" style="padding-right: 0px;">
                <span id="footerCopyRight">&copy; 2024 CentralStone Co.</span>
            </div>
            <div class="col-2" style="padding-right: 0px; text-align: right;">
                <small><span id="footerVersion">V {{versionNo}}</span></small>
            </div>
        </div>
    </footer>
    <!-- <footer>
        <div class="row" style="margin-right: auto;">
            <div class="col-1" style="padding-right: 0px;">
                V {{versionNo}}
            </div>
            <div class="col-10" style="padding-right: 0px;">
                &copy; 2021 RiverStone Group, Inc.
            </div>
            <div class="col-1" style="padding-right: 0px;">

            </div>
        </div>
    </footer> -->
</div>
